export enum AEROTRAK_ENDPOINT {
  WIDGETS = "widgets",
  DASHBOARD_WIDGETS = "layout/widgets",
  DASHBOARD_LAYOUT = "layout",
  DASHBOARD_LAYOUT_SAVE = "layout/save",
  AEROTRAK_APPS_BY_USER_ROLE = "apps-by-user-role",
  AEROTRAK_APPS = "apps",
  AEROTRAK_USER_APPS = "user-apps",
  AEROTRAK_USER_ASSIGNED_APPS = "user-assigned-apps",
  AEROTRAK_RECENT_ACTIVITIES = "recent-activities",
  AEROTRAK_TODO_LIST = "todos",
}
